import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Firebase初期化
export const firebaseApp = initializeApp(firebaseConfig);

// Firebase Authentication インスタンスを作成
export const firebaseAuth = getAuth(firebaseApp);
firebaseAuth.tenantId = import.meta.env.VITE_FIREBASE_TENANT_ID; // テナントIDを設定
firebaseAuth.languageCode = "ja";  // 日本語に設定
